import { render, staticRenderFns } from "./ScrollingImageGallery.vue?vue&type=template&id=0a13ed06&"
import script from "./ScrollingImageGallery.vue?vue&type=script&lang=js&"
export * from "./ScrollingImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports